import * as cx from 'classnames';
import { hasAds } from 'mk/bazaar/common/userUtils';
import { ZoneTargeting } from 'mk/ox';
import { adSlotRegister, adSlotUnregister } from 'mk2/containers/AdSlot/AdSlot.actions';
import { MapDispatchToPropsObject } from 'mk2/helpers/types';
import { AppState, getRequestUser } from 'mk2/reducers';
import { UserEntity } from 'mk2/schemas';
import * as React from 'react';
import { connect } from 'react-redux';
import styles from './AdSlot.mscss';

// TODO: How to sync between server and client?
let dynamicAdCount = 0;

export interface OwnProps {
    className?: string;
    style?: any;
    zone: string;
    targeting?: ZoneTargeting;
    slotId?: string;
    prefix?: string;
    forceShowAds?: boolean;

    slotRef?(r: HTMLDivElement);
}

interface StateProps {
    requestUser: UserEntity;
}

interface DispatchProps {
    onRegister(slotId: string, zone: string, targeting: ZoneTargeting);
    onUnregister(slotId: string);
}

type Props = OwnProps & StateProps & DispatchProps;

interface State {
    slotId: string;
}

class AdSlot extends React.Component<Props, State> {

    public static defaultProps = {
        prefix: 'mk-slot',
    };

    public constructor(props: Props) {
        super(props);

        this.state = {
            slotId: this.props.slotId || this.generateSlotId(),
        };
    }

    public componentDidMount() {
        this.register();
    }

    public componentWillReceiveProps(nextProps: Props) {
        // Zone has changed - unregister
        // NOTE: Should we also test targeting (deep equal)? - currently no
        if (this.props.zone !== nextProps.zone) {
            this.unregister();
            const newSlotId = nextProps.slotId || this.generateSlotId();
            this.setState({
                slotId: newSlotId,
            });
        }
    }

    public componentDidUpdate(prevProps: Props) {
        // Zone has changed - register
        // NOTE: Should we also test targeting (deep equal)? - currently no
        if (prevProps.zone !== this.props.zone) {
            this.register();
        }
    }

    public componentWillUnmount() {
        this.unregister();
    }

    public render() {
        const { className, forceShowAds, requestUser } = this.props;

        if (!forceShowAds && !hasAds(requestUser)) {
            return null;
        }

        return (
            <div id={this.state.slotId} className={cx(styles.AdSlot, className)} ref={this.props.slotRef} style={this.props.style} />
        );
    }

    private generateSlotId = () => {
        return `${this.props.prefix}-${dynamicAdCount++}`;
    };

    private register = () => {
        const { zone, targeting, onRegister, forceShowAds, requestUser } = this.props;
        if (forceShowAds || hasAds(requestUser)) {
            onRegister(this.state.slotId, zone, targeting);
        }
    };

    private unregister = () => {
        const { onUnregister, forceShowAds, requestUser } = this.props;
        if (forceShowAds || hasAds(requestUser)) {
            onUnregister(this.state.slotId);
        }
    };
}

function mapStateToProps(state: AppState, ownProps: OwnProps): StateProps {
    return {
        requestUser: getRequestUser(state),
    };
}

const mapDispatchToProps: MapDispatchToPropsObject<DispatchProps> = {
    onRegister: adSlotRegister,
    onUnregister: adSlotUnregister,
};

export default connect(mapStateToProps, mapDispatchToProps)(AdSlot);

export function resetAdCount() {
    dynamicAdCount = 0;
}
